<mat-dialog-content>
    <div class="closing-x-wrap">
        <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()"> close </mat-icon>
    </div>
    <div id="printable">
        <div id="lincenseResults">
            <h1 mat-dialog-title class="deal">ID Validation Results</h1>
            <div class="header-info">
                <span
                    >Jacket ID: <span>{{ deal.dealId }}</span></span
                >
                <span
                    >Document #: <span>{{ verif.documentId }}</span></span
                >
                <span
                    >{{ customerTitle }} Name: <span>{{ customerName }}</span></span
                >
            </div>
            <div class="result-line">
                <h2>Result</h2>
                <div class="id-check-notverified">Validation not performed</div>
            </div>

            <div class="warnings">
                <ul>
                    <li>When this ID was scanned, your dealership had reached the maximum number of ID validations for the month.</li>
                    <li>
                        Unlimited validations are available as part of an upgraded EZ DOCS package. Once your dealership enrolls in this package, you can
                        validate this ID by clicking the Submit for Validation button.
                    </li>
                    <li>Contact us at {{ tenantSupportPhone }} to learn more.</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="print-wrap">
        <button (click)="close()" class="primary" mat-button>Okay</button>
    </div>
</mat-dialog-content>
